<div>
        <form [formGroup]="form" *ngIf="form">
            <div *ngFor="let field of formFields$ | async" class="form-row">
                <emm-dynamic-menu-form-field
                    [formField]="field" [form]="form" [itemTag]="itemTag"
                    [selectedSubmenu]="selectedSubmenu"
                    [selectedLocation]="selectedLocation"
                    [nodeId]="nodeId" [itemTagPath]="this.itemTagPath"
                    [selectedFeatureScope]="selectedFeatureScope"
                    [effectiveDate]="effectiveDate"
                    [selectedLanguage]="language"
                    [isCascade]="isCascade"
                    (removeLocalAttribute)="handleRemoveLocalAttribute($event)"
                ></emm-dynamic-menu-form-field>
            </div>
        </form>
</div>
